export default {"src":"/_next/static/media/logo-color.ec155a7f.svg","height":27,"width":187,"blurWidth":0,"blurHeight":0};